<template>
    <v-form ref="form" v-model="valid">
        <v-container class="room rounded-xl pb-4">
            <v-row class="mt-0 px-4">
                <v-col cols="10" md="8" order="0">
                    <v-text-field
                        dense
                        outlined
                        class="rounded-lg"
                        v-model="name"
                        :rules="nameRules"
                        label="Nome do Quarto"
                        :error="hasRoomNameError"
                        :error-messages="roomNameErrors"
                        hide-details="auto"
                        @blur="validateRoomName"
                        required
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="3" order="2" order-md="1">
                    <v-select
                        dense
                        class="rounded-lg"
                        :items="[1,2,3]"
                        label="Número de Hóspedes no Quarto"
                        v-model="guests"
                        :rules="guestsRules"
                        hide-details="auto"
                        outlined
                    ></v-select>
                </v-col>
                <v-col cols="2" md="1" order="1" order-md="2" class="d-flex justify-end">
                    <v-btn
                        icon
                        outlined
                        small
                        color="error"
                        :disabled="roomIndex === 1"
                        @click="$emit('removeRoom', roomIndex)"
                    >
                        <v-icon>mdi-alpha-x</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" order="3">
                    <v-textarea
                        dense
                        class="rounded-lg"
                        outlined
                        rows="3"
                        required
                        v-model="description"
                        :rules="descriptionRules"
                        label="Descrição"
                    ></v-textarea>
                </v-col>
            </v-row>
            <div class="mb-2 px-4">
                <v-btn
                    depressed
                    small
                    outlined
                    class="rounded-lg"
                    color="primary"
                    type="button"
                    @click="addFare"
                >
                    Adicionar Tarifa
                </v-btn>
            </div>
            <v-row v-if="$vuetify.breakpoint.smAndDown">
                <v-col cols="12">
                    <fare
                        v-for="(fare, index) in fares"
                        v-on:removeFare="removeFare"
                        v-on:fare-state-changed="onFareStateChanged"
                        :fareIndex="fare.key"
                        ref="fares" :key="fare.key"
                        :room-fare="getRoomFare(index)"
                        :disabled-days="getDisabledDaysForFare(fare.key)"
                    />
                </v-col>
            </v-row>
            <div v-else class="mt-0 px-4">
                <table class="fare-table rounded-lg">
                    <thead>
                        <tr>
                            <th>Tarifa</th>
                            <th>Café da Manhã</th>
                            <th>Valor da Diária</th>
                            <th>Tarifa válida até</th>
                            <th>Excluir</th>
                        </tr>
                    </thead>
                    <fare
                        v-for="(fare, index) in fares"
                        v-on:removeFare="removeFare"
                        v-on:fare-state-changed="onFareStateChanged"
                        :fareIndex="fare.key"
                        ref="fares" :key="fare.key"
                        :room-fare="getRoomFare(index)"
                        :disabled-days="getDisabledDaysForFare(fare.key)"
                    />
                    <tfoot>
                        <tr>
                            <td colspan="7">
                                <span class="d-flex justify-end">
                                    Tarifas refletidas com
                                    <v-icon
                                        color="primary"
                                        x-small
                                        class="px-1"
                                    >
                                        mdi-heart
                                    </v-icon>
                                    pela Onfly
                                </span>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </v-container>
    </v-form>
</template>

<script>
import Fare from "./Fare.vue";

export default {
    name: "Room",
    components: {
        Fare
    },
    props: {
        roomIndex: {
            type: Number
        },
        hotelRoom: {
            type: Object
        }
    },
    data: () => ({
        valid: false,
        name: '',
        description: '',
        guests: '',
        deleted: false,
        fares: [{
            key: 1
        }],
        fareStates: {},
        nameRules: [
            v => !!v || 'O nome do quarto é obrigatorio'
        ],
        guestsRules: [
            v => !!v || 'O número de hóspedes é obrigatorio'
        ],
        descriptionRules: [
            v => !!v || 'A descrição é obrigatória',
            v => v.length > 30 || 'A descrição deve conter pelo menos 30 caracteres'
        ],
        roomNameErrors: [],
    }),
    methods: {
        getData() {
            let data = {
                "name": this.name,
                "description": this.description,
                "guests": this.guests,
                "fares": this.$refs.fares.map(fare => {
                    return fare.getData();
                })
            }

            if (this.hotelRoom !== null) {
                data.id = this.hotelRoom.id;
            }

            return data;
        },
        setData(){
            this.name = this.hotelRoom.name;
            this.description = this.hotelRoom.description;
            this.guests = this.hotelRoom.guests;

            for(let i = 1; i < this.hotelRoom.fares.length; i++){
                this.addFare();
            }
        },
        addFare() {
            let lastKey = this.fares[this.fares.length - 1].key;
            this.fares.push({
                key: lastKey + 1
            })
        },
        removeFare(key) {
            let indexOf = this.fares.findIndex(room => {
                return room.key === key;
            });
            this.fares.splice(indexOf, 1);
            this.hotelRoom.fares.splice(indexOf, 1);
            this.$delete(this.fareStates, key);
        },
        onFareStateChanged (payload) {
            this.$set(this.fareStates, payload.fareKey, {
                weekDays: payload.weekDays,
                breakfast: payload.breakfast
            });
        },
        getDisabledDaysForFare (fareKey) {
            return this.disabledDaysByFare[fareKey] || [];
        },
        validate() {
            this.$refs.form.validate();
            const roomNameValid = !!this.name && !this.hasRoomNameError;
            const guestsValid = !!this.guests;
            const descriptionValid = !!this.description && this.description.length > 30;
            const allFaresHaveDays = this.$refs.fares.every(fare => fare.hasSelectedAtLeastOneWeekDay);
            const allFaresHaveValidExpiration = this.$refs.fares.every(fare => fare.hasValidExpirationDate);
            const allFaresHaveValidValue = this.$refs.fares.every(fare => fare.hasValidValue);
            this.valid = roomNameValid && guestsValid && descriptionValid && allFaresHaveDays && allFaresHaveValidExpiration && allFaresHaveValidValue;
        },
        async validateRoomName() {
            if (!this.name) {
                return;
            }

            this.hotelNameErrors = [];

            const response = await axios.get(this.getCheckRestrictedNamesUrl());
            if ( response?.data?.success === true) {
                this.roomNameErrors = []
            } else {
                this.roomNameErrors = [response.data.message]
            }

            this.$nextTick(() => {
                this.$refs.form.inputs.find(input => input.$attrs.label === 'Nome do Quarto')?.validate();
            });
        },
        getRoomFare (index) {
            if (this.hotelRoom?.fares && this.hotelRoom.fares?.length) {
                return this.hotelRoom.fares[index];
            }

            return null;
        },
        getCheckRestrictedNamesUrl() {
            return `/api/v1/owner-actions/${this.$route.params.tokenHash}/check-restricted-names/?string=${encodeURIComponent(this.name)}`
        },
        hasSameBreakfastType(fareA, fareB) {
            return !!fareA.breakfast === !!fareB.breakfast;
        },
        getSiblingFares(fareKey) {
            const currentFare = this.fareStates[fareKey];
            return Object.keys(this.fareStates)
                .filter(key => key !== fareKey)
                .map(key => this.fareStates[key])
                .filter(fare => this.hasSameBreakfastType(fare, currentFare));
        },
        collectClaimedDays(fares) {
            const days = new Set();
            fares.forEach(fare => fare.weekDays.forEach(day => days.add(day)));
            return [...days];
        },
    },
    computed: {
        hasRoomNameError () {
            return this.roomNameErrors.length > 0;
        },
        disabledDaysByFare() {
            const result = {};
            for (const key of Object.keys(this.fareStates)) {
                result[key] = this.collectClaimedDays(this.getSiblingFares(key));
            }
            return result;
        }
    },
    created() {
        if(this.hotelRoom !== null){
            this.setData();
        }
    }
}
</script>

<style lang="scss" scoped>
.room {
    border: 1px solid #F5F5F6;
    margin-bottom: 2rem;
    padding: 0.75rem 0.25rem;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    background-color: #ffffff;
}

.fare-table {
    width: 100%;
    border-spacing: 0;
    border: 1px solid #E6E6E7;

    tr,
    tbody tr td {
        border: 1px solid #E6E6E7;
    }

    thead,
    {
        background-color: #F5F5F6;

        tr th {
            font-size: 0.875rem;
            font-weight: 600;
            color: #696A71;
            padding: 0.5rem 1rem;
        }
    }

    tfoot
    {
        background-color: #F5F5F6;

        tr td {
            font-size: 0.75rem;
            font-weight: 500;
            color: #696A71;
            padding: 0.25rem 0.5rem;
        }
    }
}
</style>
